/**
 * 支援アドインの SAML 認証開始エンドポイント (Lambda にルーティングされる相対パス)。
 *
 * `openAuthDialog(addinLoginStartUrl)` の形で Dialog API 起動時の navigate 先として使用する。
 */
export const addinLoginStartUrl = "/user-tokens/addin/login-start";
